module.exports = __webpack_public_path__ + "static/media/zocalo1.cd37e8cd.jpg";